/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  primaryLanguage: '',
  selectedLanguage: '',
  selectedArticle: {},
  kbFormDisabledStatus: false,
  formHasPendingChanges: false,
  isPollingKBUploads: false,
  knowledgeBaseId: null,
  missingTranslationInfo: {}
};

const knowledgeBaseSlice = createSlice({
  name: 'knowledgeBases',
  initialState,
  reducers: {
    knowledgeBasesPrimaryLanguage: (state, action) => ({
      ...state,
      primaryLanguage: action.payload
    }),
    knowledgeBasesSelectedLanguage: (state, action) => ({
      ...state,
      selectedLanguage: action.payload
    }),
    clearKnowledgeBasesSelectedLanguage: (state) => ({
      ...state,
      selectedLanguage: ''
    }),
    knowledgeBaseSelectedArticle: (state, action) => ({
      ...state,
      selectedArticle: action.payload
    }),
    knowledgeBaseFormDisabledStatus: (state, action) => {
      state.kbFormDisabledStatus = action.payload;
    },
    knowledgeBaseFormHasPendingChanges: (state, action) => {
      state.formHasPendingChanges = action.payload;
    },
    knowledgeBaseIsPollingKBUploads: (state, action) => {
      state.isPollingKBUploads = action.payload;
    },
    knowledgeBaseId: (state, action) => {
      state.knowledgeBaseId = action.payload;
    },
    knowledgeBaseMissingTranslationInfo: (state, action) => ({
      ...state,
      missingTranslationInfo: action.payload
    })
  }
});

export const knowledgeBaseActions = knowledgeBaseSlice.actions;

export default knowledgeBaseSlice.reducer;
